import { DateTime } from 'luxon';
import { AbstractFrontend } from '../../shared/core/abstract-prototype-object';
import { AbstractBackend } from '../abstract-contract';

export interface CoreItemBackend extends AbstractBackend {
  id: string;
  sk: string;

  version: string;

  parentId?: string;

  title?: string;
  description?: string;

  isArchived?: boolean;

  type?: any;

  subData?: any; // unsafeSubdata
  unsafeSubData?: any; //  ✅ Read, ✅ Write
  publicSubData?: any; //  ✅ Read, ❌ Write
  privateSubData?: any; // ❌ Read, ❌ Write

  status?: string;
  statusTimeStr?: string;

  startTimeStr?: string;
  endTimeStr?: string;

  isPaid?: boolean;
}

export interface CoreItem extends AbstractFrontend {
  sk: string;

  coreType: CoreItemType;

  version: string;

  type?: any;
  parentId?: string;

  title?: string;
  description?: string;

  isArchived?: boolean;

  subData?: any; // unsafeSubdata
  unsafeSubData?: any;
  publicSubData?: any;
  privateSubData?: any;

  status?: any;
  statusTime?: DateTime;

  startTime?: DateTime;
  endTime?: DateTime;

  isPaid?: boolean;
}

export enum CoreItemType {
  interviewMessage = 'a',
  board = 'b',
  chat = 'c',
  creditHistory = 'd',
  tag = 'g',
  referral = 'f',
  interview = 'i',
  job = 'j',
  goal = 'l',
  chatMessage = 'm',
  solution = 'o', // deprecated
  relation = 'r',
  resume = 's',
  workspace = 'w', // placeholder
}

export enum VertexRelations {
  has = 'h',
  includes = 'i',
  isBefore = 'b',
  watches = 'w', // watch a board => favorite a board
}

export const VertexRelationsAlias = {
  superTaskToSubTask: VertexRelations.includes,
  beforeTaskToAfterTask: VertexRelations.isBefore,
  boardPinBoard: VertexRelations.watches,
  coreItemAssignTag: VertexRelations.has,
};

export enum VertexTravelHistoryRelations {
  transfers = 't',
  delegates = 'd',
}

export interface VertexRelationship {
  from: VertexIdAndType;
  to: VertexIdAndType;
  relation: VertexRelations;
  createdTimeStr?: string;
  displayOrderId?: number;
}

export interface VertexIdAndType {
  id?: string;
  coreType?: CoreItemType;
}
